/* eslint-disable react/destructuring-assignment */
import { Column } from "@ant-design/plots";
import { Empty, Skeleton } from "antd";
import React, { memo } from "react";

const BarChart = props => {
  const { graphData, type, xField, yField, seriesField, colors } = props;
  const config = {
    data: graphData,
    xField: xField || "type",
    yField: yField || "value",
    seriesField: seriesField || "type",
    color: colors,
    xAxis: {
      label: {
        formatter: text => {
          return text
            .split(" ")
            .map(word => word[0])
            .join("");
        },
        // autoHide: false,
      },
    },
    height: 320,
    autoFit: true,
    isGroup: type === "GROUP",
    isStack: type === "STACK",
    legend: {
      position: "bottom",
      flipPage: false,
    },
    maxColumnWidth: props.width || 8,
    interactions: [
      {
        type: "element-active",
      },
    ],
    columnStyle: {
      radius: [20, 20, 20, 20],
    },
    label: false,
  };

  return (
    <Skeleton className="h-[320px]" avatar loading={props.loader} active>
      {graphData?.length > 0 ? (
        <Column className="flex-1" {...config} />
      ) : (
        <Empty className="h-[320px] flex flex-col justify-center" />
      )}
    </Skeleton>
  );
};

export default memo(BarChart); // converted into pure component to prevent unwanted rendering
